import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { AssetsIcon } from '@atlaskit/temp-nav-app-icons/assets';

import type { GlobalShortcutsItem } from '../../types';

import { messages } from './messages';

export default function assets(fallbackUrl: () => string): GlobalShortcutsItem {
	return {
		icon: <AssetsIcon size="20" />,
		label: <FormattedMessage {...messages.label} />,
		fallbackUrl,
	};
}
